











import { Component, Vue, Prop } from "vue-property-decorator";
import { IShop } from "@/store/interfaces/shops.ts";
import { MERCHANTS_PER_PAGE } from "@/config";

@Component({
  name: "ReadmoreBtn"
})
export default class ReadmoreBtn extends Vue {
  @Prop({ default: null })
  merchant: IShop;

  dataCount: number = MERCHANTS_PER_PAGE;

  showMore(letter, count, e) {
    e.target.style.display = "none";

    this.dataCount = this.dataCount + MERCHANTS_PER_PAGE;
    this.$emit("more", letter, this.dataCount);

    if (this.dataCount > count) {
      e.target.style.display = "none";
    } else {
      e.target.style.display = "block";
    }
  }
}
